import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { CommonRootState } from "@common/types/common-root-state-type";

export interface NudgeState {
  // nudgeIds the user dismissed this session. Persisting the dismissal in the
  // store (not in per-mount component state) is what survives the extension's
  // constant WhatsApp-Web re-injection churn — a local useState would reset to
  // `false` on every remount and re-show a dismissed banner. (Server 30d TTL
  // handles across-session suppression.)
  dismissedNudgeIds: string[];
}

const initialState: NudgeState = {
  dismissedNudgeIds: [],
};

const NudgeSlice = createSlice({
  name: "Nudge",
  initialState,
  reducers: {
    dismissNudge(state, action: PayloadAction<string>) {
      const nudgeId = action.payload;
      if (nudgeId && !state.dismissedNudgeIds.includes(nudgeId)) {
        state.dismissedNudgeIds.push(nudgeId);
      }
    },
  },
});

export const { dismissNudge } = NudgeSlice.actions;

export const selectNudgeDismissed = (
  state: CommonRootState,
  nudgeId: string | null | undefined
): boolean =>
  !!nudgeId && state.NudgeReducer.dismissedNudgeIds.includes(nudgeId);

export default NudgeSlice.reducer;
